import * as THREE from 'three';

export function facadeTextures(wallHex, litChance){
  const W=256, H=224; const c = document.createElement('canvas'); c.width=W; c.height=H; const g = c.getContext('2d');
  const e = document.createElement('canvas'); e.width=W; e.height=H; const eg = e.getContext('2d');
  g.fillStyle = wallHex; g.fillRect(0,0,W,H);
  // subtle grime
  for (let i=0;i<1400;i++){ g.fillStyle = `rgba(0,0,0,${Math.random()*0.06})`; g.fillRect(Math.random()*W, Math.random()*H, 2, 2); }
  eg.fillStyle = '#000'; eg.fillRect(0,0,W,H);
  const cols = 4, rows = 4, cw = W/cols, ch = H/rows;
  for (let r=0;r<rows;r++) for (let col=0;col<cols;col++){
    const x = col*cw + cw*0.18, y = r*ch + ch*0.16, w = cw*0.64, h = ch*0.6;
    const shade = 30 + Math.random()*30;
    g.fillStyle = `rgb(${shade+10},${shade+16},${shade+30})`; g.fillRect(x,y,w,h);
    g.fillStyle = 'rgba(255,255,255,.12)'; g.fillRect(x,y,w,h*0.18);
    g.fillStyle = 'rgba(0,0,0,.25)'; g.fillRect(x, y+h-2, w, 2);
    if (Math.random() < litChance){ const warm = Math.random(); eg.fillStyle = warm<0.7 ? `rgb(${210+Math.random()*45},${170+Math.random()*50},${90+Math.random()*60})` : `rgb(${150+Math.random()*40},${200+Math.random()*40},${230})`; eg.fillRect(x+1,y+1,w-2,h-2); }
  }
  const map = new THREE.CanvasTexture(c), em = new THREE.CanvasTexture(e);
  for (const t of [map, em]){ t.wrapS = t.wrapT = THREE.RepeatWrapping; t.repeat.set(1/16, 1/14); t.colorSpace = THREE.SRGBColorSpace; t.anisotropy = 4; }
  return {map, em};
}
export let facadeSet = [];
export const roofMat = new THREE.MeshStandardMaterial({color:'#4a4649', roughness:.95});
export const propMat = new THREE.MeshStandardMaterial({color:'#6c6a6e', roughness:.9});
export const CHAR = new THREE.Color('#1b1512');
export function streetAO(mat){ // darken facades toward street level — fake ambient occlusion in the canyons
  mat.onBeforeCompile = sh => {
    sh.vertexShader = sh.vertexShader.replace('#include <common>', '#include <common>\nvarying float vWY;').replace('#include <begin_vertex>', '#include <begin_vertex>\nvWY = (modelMatrix * vec4(transformed, 1.0)).y;');
    sh.fragmentShader = sh.fragmentShader.replace('#include <common>', '#include <common>\nvarying float vWY;').replace('#include <map_fragment>', '#include <map_fragment>\ndiffuseColor.rgb *= mix(0.55, 1.0, smoothstep(0.0, 28.0, vWY));');
  };
  mat.customProgramCacheKey = () => 'streetao' + (mat.map?'m':'') + (mat.bumpMap?'b':'') + (mat.emissiveMap?'e':'');
}
export function prepareFacades(def){
  for (const f of facadeSet){ f.map.dispose(); f.em.dispose(); }
  facadeSet = def.walls.map(hex => { const f = facadeTextures(hex, def.lit*(0.5+Math.random()*0.7)); const chunk = f.map.clone(); chunk.repeat.set(1, 1); chunk.needsUpdate = true; return {hex, ...f, chunk}; });   // chunk: one window grid per rubble face
}

